// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-sec {
  height: 100vh;
}
.layout-sec aside.ant-layout-sider {
  background: #fff;
  border-right: 1px solid #edf2f7;
}
.layout-sec aside.ant-layout-sider .img {
  padding: 20px 0px;
  text-align: center;
}
.layout-sec .ant-layout {
  height: calc(100vh - 30px);
  background: #ffffff;
  position: relative;
}
.layout-sec .main-content-wrapper {
  padding: 30px 20px 40px 20px;
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.layout-sec .page-title,
.layout-sec .sec-title {
  font-weight: 600;
  font-size: 16px !important;
  margin-bottom: 20px;
}
.layout-sec .ant-menu-dark .ant-menu-item,
.layout-sec .ant-menu-dark .ant-menu-item-group-title,
.layout-sec .ant-menu-dark .ant-menu-item > a,
.layout-sec .ant-menu-dark .ant-menu-item > span > a {
  color: #77d0a7;
  border: 1px solid white;
}
.layout-sec .ant-menu-dark .ant-menu-item-selected > a,
.layout-sec .ant-menu-dark .ant-menu-item-selected > span > a,
.layout-sec .ant-menu-dark .ant-menu-item-selected > a:hover,
.layout-sec .ant-menu-dark .ant-menu-item-selected > span > a:hover,
.layout-sec .ant-menu-item a:hover {
  color: #ffffff !important;
}
.sidebar-sec {
  height: 100%;
}
.sidebar-sec .overlay {
  transition: all ease-in-out 0.5s;
}
.sidebar-sec .overlay.open {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 99;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  transition: all ease-in-out 0.5s;
}
.sidebar-sec aside {
  height: 100%;
  background: #fff;
  z-index: 999;
}
.sidebar-sec aside .ant-layout-sider-zero-width-trigger {
  background-color: #c11b2f;
  top: 6px;
  inset-inline-end: -30px;
  width: 30px;
  height: 30px;
  font-size: 16px;
  z-index: 9999;
}
.sidebar-sec .logo {
  width: 100%;
  padding: 20px 15px 20px 15px;
  margin-bottom: 20px;
}
.sidebar-sec .logo img {
  width: 100%;
  height: 150px;
  object-fit: contain;
  object-position: center;
}
.sidebar-sec ul.ant-menu {
  background: transparent;
  border-right: unset;
  height: 90%;
  display: flex;
  flex-direction: column;
}
.sidebar-sec ul.ant-menu li.ant-menu-item {
  padding: 4px 10px 4px 10px !important;
  margin: 0;
  border-radius: unset;
  width: 100%;
  height: unset;
  border: 3px solid #ffffff;
}
.sidebar-sec ul.ant-menu li.ant-menu-item.menu-account {
  margin-top: auto;
}
.sidebar-sec ul.ant-menu li.ant-menu-item:last-child {
  margin-bottom: 0;
}
.sidebar-sec ul.ant-menu li.ant-menu-item.ant-menu-item-selected,
.sidebar-sec ul.ant-menu li.ant-menu-item:hover {
  background-color: #ffffff !important;
  border-left: 3px solid #c11b2f;
}
.sidebar-sec ul.ant-menu li.ant-menu-item.ant-menu-item-selected a,
.sidebar-sec ul.ant-menu li.ant-menu-item:hover a {
  color: #c11b2f !important;
}
.sidebar-sec ul.ant-menu li.ant-menu-item.ant-menu-item-selected a svg,
.sidebar-sec ul.ant-menu li.ant-menu-item:hover a svg {
  transition: all 0.4s ease-in-out;
}
.sidebar-sec ul.ant-menu li.ant-menu-item.ant-menu-item-selected a svg path,
.sidebar-sec ul.ant-menu li.ant-menu-item:hover a svg path {
  transition: all 0.4s ease-in-out;
  stroke: #c11b2f;
}
.sidebar-sec ul.ant-menu li.ant-menu-item.ant-menu-item-selected a svg rect,
.sidebar-sec ul.ant-menu li.ant-menu-item:hover a svg rect {
  transition: all 0.4s ease-in-out;
  fill: #c11b2f;
}
.sidebar-sec ul.ant-menu li.ant-menu-item .ant-menu-title-content a {
  display: flex;
  align-items: center;
  width: 100%;
  transition: all 0.4s ease-in-out;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #222;
}
.sidebar-sec ul.ant-menu li.ant-menu-item .ant-menu-title-content a .menu-icon {
  height: 32px;
  width: 32px;
  margin-right: 10px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 6px;
}
.sidebar-sec ul.ant-menu li.ant-menu-item .ant-menu-title-content a .menu-icon svg {
  transition: all 0.4s ease-in-out;
}
.sidebar-sec ul.ant-menu li.ant-menu-item .ant-menu-title-content a .menu-icon svg path {
  transition: all 0.4s ease-in-out;
}
.sidebar-sec ul.ant-menu.ant-menu-inline-collapsed li.ant-menu-item a .menu-icon-text {
  opacity: 0;
}
.sidebar-sec .ant-menu .kl-sidebar-logout a {
  transition: all 0.4s ease-in-out;
}
.sidebar-sec .ant-menu .kl-sidebar-logout a svg {
  transition: all 0.4s ease-in-out;
}
.sidebar-sec .ant-menu .kl-sidebar-logout a svg path {
  transition: all 0.4s ease-in-out;
  fill: #77d0a7;
}
.gx-layout-sider-scrollbar {
  height: calc(100% - 10px) !important;
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .layout-sec .ant-layout {
    height: 100vh;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .layout-sec .ant-layout {
    height: 100vh;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .layout-sec .ant-layout {
    height: 100vh;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .layout-sec .main-content-wrapper {
    padding: 40px 15px 0 15px;
    overflow-x: hidden;
  }
  .layout-sec .ant-layout {
    height: 100vh !important;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .layout-sec .main-content-wrapper {
    padding: 40px 15px 15px 15px;
    overflow-x: hidden;
  }
  .gx-layout-sider-scrollbar {
    height: calc(100% - 90px) !important;
  }
  .sidebar-sec {
    position: absolute;
    z-index: 99999;
  }
  .ant-layout {
    height: 100vh !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layout/Sidebar/Sidebar.less"],"names":[],"mappings":"AAEA;EACE,aAAA;AADF;AAAA;EAII,gBAAA;EACA,+BAAA;AADJ;AAJA;EAOM,iBAAA;EACA,kBAAA;AAAN;AARA;EAYI,0BAAA;EACA,mBAAA;EACA,kBAAA;AADJ;AAbA;EAiBI,4BAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AADJ;AApBA;;EAyBI,gBAAA;EACA,0BAAA;EACA,mBAAA;AADJ;AA1BA;;;;EAiCI,cAAA;EACA,uBAAA;AADJ;AAjCA;;;;;EAyCI,yBAAA;AADJ;AAKA;EACE,YAAA;AAHF;AAEA;EAGI,gCAAA;AAFJ;AADA;EAMI,8BAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,kCAAA;UAAA,0BAAA;EACA,gCAAA;AAFJ;AAVA;EAgBI,YAAA;EACA,gBAAA;EACA,YAAA;AAHJ;AAfA;EAoBM,yBAAA;EACA,QAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAFN;AAxBA;EA8BI,WAAA;EACA,4BAAA;EACA,mBAAA;AAHJ;AA7BA;EAkCM,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFN;AAnCA;EAyCI,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAHJ;AA1CA;EA+CM,qCAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;AAFN;AAIM;EACE,gBAAA;AAFR;AAKM;EACE,gBAAA;AAHR;AAKM;;EAEE,oCAAA;EACA,8BAAA;AAHR;AAAM;;EAKI,yBAAA;AADV;AAJM;;EAOM,gCAAA;AACZ;AARM;;EASQ,gCAAA;EAEA,eAAA;AAEd;AAbM;;EAcQ,gCAAA;EACA,aAAA;AAGd;AA/EA;EAmFU,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AADV;AAzFA;EA4FY,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AAAZ;AApGA;EAsGc,gCAAA;AACd;AAvGA;EAwGgB,gCAAA;AAEhB;AASI;EAIQ,UAAA;AAVZ;AA7GA;EAgIM,gCAAA;AAhBN;AAhHA;EAkIQ,gCAAA;AAfR;AAnHA;EAoIU,gCAAA;EACA,aAAA;AAdV;AAqBA;EACE,oCAAA;AAnBF;AAqCA;EACE;IAEI,aAAA;EApCJ;AACF;AA0CA;EACE;IAEI,aAAA;EAzCJ;AACF;AA+CA;EACE;IAEI,aAAA;EA9CJ;AACF;AAoDA;EACE;IAEI,yBAAA;IACA,kBAAA;EAnDJ;EAgDA;IAMI,wBAAA;EAnDJ;AACF;AAyDA;EACE;IAEI,4BAAA;IACA,kBAAA;EAxDJ;EA2DA;IACE,oCAAA;EAzDF;EA4DA;IACE,kBAAA;IACA,cAAA;EA1DF;EA6DA;IACE,wBAAA;EA3DF;AACF","sourcesContent":["@import url(\"../../assets/Styles/variables.less\");\n\n.layout-sec {\n  height: 100vh;\n\n  aside.ant-layout-sider {\n    background: #fff;\n    border-right: 1px solid #edf2f7;\n    .img {\n      padding: 20px 0px;\n      text-align: center;\n    }\n  }\n  .ant-layout {\n    height: calc(100vh - 30px);\n    background: #ffffff;\n    position: relative;\n  }\n  .main-content-wrapper {\n    padding: 30px 20px 40px 20px;\n    height: 100vh;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n  }\n  .page-title,\n  .sec-title {\n    font-weight: 600;\n    font-size: 16px !important;\n    margin-bottom: 20px;\n  }\n  .ant-menu-dark .ant-menu-item,\n  .ant-menu-dark .ant-menu-item-group-title,\n  .ant-menu-dark .ant-menu-item > a,\n  .ant-menu-dark .ant-menu-item > span > a {\n    color: @light-primary-color;\n    border: 1px solid white;\n  }\n  .ant-menu-dark .ant-menu-item-selected > a,\n  .ant-menu-dark .ant-menu-item-selected > span > a,\n  .ant-menu-dark .ant-menu-item-selected > a:hover,\n  .ant-menu-dark .ant-menu-item-selected > span > a:hover,\n  .ant-menu-item a:hover {\n    color: @white-color !important;\n  }\n}\n\n.sidebar-sec {\n  height: 100%;\n  .overlay {\n    transition: all ease-in-out 0.5s;\n  }\n  .overlay.open {\n    background: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n    z-index: 99;\n    backdrop-filter: blur(4px);\n    transition: all ease-in-out 0.5s;\n  }\n\n  aside {\n    height: 100%;\n    background: #fff;\n    z-index: 999;\n    .ant-layout-sider-zero-width-trigger {\n      background-color: @primary-color;\n      top: 6px;\n      inset-inline-end: -30px;\n      width: 30px;\n      height: 30px;\n      font-size: 16px;\n      z-index: 9999;\n    }\n  }\n  .logo {\n    width: 100%;\n    padding: 20px 15px 20px 15px;\n    margin-bottom: 20px;\n    img {\n      width: 100%;\n      height: 150px;\n      object-fit: contain;\n      object-position: center;\n    }\n  }\n  ul.ant-menu {\n    background: transparent;\n    border-right: unset;\n    height: 90%;\n    display: flex;\n    flex-direction: column;\n    li.ant-menu-item {\n      padding: 4px 10px 4px 10px !important;\n      margin: 0;\n      border-radius: unset;\n      width: 100%;\n      height: unset;\n      border: 3px solid @white-color;\n\n      &.menu-account {\n        margin-top: auto;\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n      &.ant-menu-item-selected,\n      &:hover {\n        background-color: @white-color !important;\n        border-left: 3px solid @primary-color;\n        a {\n          color: @primary-color !important;\n          svg {\n            transition: all 0.4s ease-in-out;\n            path {\n              transition: all 0.4s ease-in-out;\n              // fill: @primary-color;\n              stroke: @primary-color;\n            }\n            rect {\n              transition: all 0.4s ease-in-out;\n              fill: @primary-color;\n            }\n          }\n        }\n      }\n      .ant-menu-title-content {\n        a {\n          display: flex;\n          align-items: center;\n          width: 100%;\n          transition: all 0.4s ease-in-out;\n          font-size: 14px;\n          font-weight: 400;\n          text-align: left;\n          color: #222;\n          .menu-icon {\n            height: 32px;\n            width: 32px;\n            margin-right: 10px;\n            background: @white-color;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 50%;\n            padding: 6px;\n            svg {\n              transition: all 0.4s ease-in-out;\n              path {\n                transition: all 0.4s ease-in-out;\n                // fill: @primary-color;\n              }\n            }\n          }\n        }\n        &:hover {\n        }\n      }\n    }\n\n    &.ant-menu-inline-collapsed {\n      li.ant-menu-item {\n        a {\n          .menu-icon-text {\n            opacity: 0;\n          }\n        }\n      }\n    }\n  }\n\n  .ant-menu .kl-sidebar-logout {\n    a {\n      transition: all 0.4s ease-in-out;\n      svg {\n        transition: all 0.4s ease-in-out;\n        path {\n          transition: all 0.4s ease-in-out;\n          fill: #77d0a7;\n        }\n      }\n    }\n  }\n}\n\n.gx-layout-sider-scrollbar {\n  height: calc(100% - 10px) !important;\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n  .layout-sec {\n    .ant-layout {\n      height: 100vh;\n    }\n  }\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n  .layout-sec {\n    .ant-layout {\n      height: 100vh;\n    }\n  }\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n  .layout-sec {\n    .ant-layout {\n      height: 100vh;\n    }\n  }\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n  .layout-sec {\n    .main-content-wrapper {\n      padding: 40px 15px 0 15px;\n      overflow-x: hidden;\n    }\n    .ant-layout {\n      height: 100vh !important;\n    }\n  }\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  .layout-sec {\n    .main-content-wrapper {\n      padding: 40px 15px 15px 15px;\n      overflow-x: hidden;\n    }\n  }\n  .gx-layout-sider-scrollbar {\n    height: calc(100% - 90px) !important;\n  }\n\n  .sidebar-sec {\n    position: absolute;\n    z-index: 99999;\n  }\n\n  .ant-layout {\n    height: 100vh !important;\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
